export enum RadarDetectionDependencyType {
  INTERNAL = 'INTERNAL',
  EXTERNAL = 'EXTERNAL',
}
